module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAKlBMVEUAAAAfoP8blP8Abf8fn/8fn/8fn/8fnf8cnf8foP8eoP8fn/8gn/8foP9yl0jKAAAADXRSTlMAmRIDjP2SOSRyUK1ASgCJKwAAAHtJREFUGNNjQAbsgkAgBWRYHmBgvAsE1wwYmHMnMDDeUFJSUmZgMAHyGS+BlTL7OjPA2CZXDEBsmDCIDRUGs6HCYDZEGMZmzgUKmy0AsiFmM+gKANlg1VA2SDWcbQ0UhqthQLAZsLJvKEFAL5B9NxQC7goA/QgDBcheBwBCUSitVZJmKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/HandleEdit.png
// module id = 0OfM
// module chunks = 104